/**
 * @description 压痛点选中文字
 * @param type，腰椎,正面
 * @returns 
 */
const getText = (data: any, type: any): any => {
    let showText: any = [];
    if (type == '腰椎') {
        const keyArr = ['棘旁压痛', '棘上压痛', 'L3横突', '臀上皮神经', '臀中肌', '臀小肌', '臀大肌', '髂后上棘', '梨状肌', '股方肌', '腓肠肌外侧头', '腓肠肌内侧头', '无压痛点']
        keyArr.forEach((ele: any, i: any) => {
            if (ele === '棘旁压痛' || ele === '棘上压痛') {
                if (data.value[ele] && data.value[ele]['L1']) {
                    showText.push(ele + 'L1')
                }
                if (data.value[ele] && data.value[ele]['L2']) {
                    showText.push(ele + 'L2')
                }
                if (data.value[ele] && data.value[ele]['L3']) {
                    showText.push(ele + 'L3')
                }
                if (data.value[ele] && data.value[ele]['L4']) {
                    showText.push(ele + 'L4')
                }
                if (data.value[ele] && data.value[ele]['L5']) {
                    showText.push(ele + 'L5')
                }
            } else {
                if (data.value[ele]) {
                    showText.push(ele)
                }
            }
        })
        return showText
    } else if (type == '正面') {
        const keyArr = ['锁骨上窝', '胸锁乳突肌锁骨附着处', '气户', '喙突', , '无压痛点']
        keyArr.forEach((ele: any, i: any) => {
            if (data.value[ele]) {
                showText.push(ele);
            }
        })
        return showText
    } else if (type == '侧面') {
        const keyArr = ['颞骨乳突', '乳突后下方', '1', '2', '3', '4', '5', '6', '7', '颈横纹', '无压痛点'];
        const TextArr = ['颞骨乳突', '乳突后下方', '横突1', '横突2', '横突3', '横突4', '横突5', '横突6', '横突7', '颈横纹', '无压痛点'];
        keyArr.forEach((ele: any, i: any) => {
            if (data.value[ele]) {
                showText.push(TextArr[i]);
            }
        })
        return showText
    } else if (type == '背面') {
        const keyArr = ['上项线', '寰枕间隙', '寰枢间隙', 'C2-3', 'C3-4', 'C4-5', 'C5-6', 'C6-7', 'C7', 'T1', 'T2', 'T3', '颈横纹',
            '内上角', '内缘', '外缘', '无压痛点'
        ]
        const TextArr = ['上项线(枕外隆凸两侧)', '寰枕间隙', '寰枢间隙', '关节间隙C2-3', '关节间隙C3-4', '关节间隙C4-5', '关节间隙C5-6', '关节间隙C6-7',
            '棘突侧方C7',
            '棘突侧方T1', '棘突侧方T2', '棘突侧方T3', '颈横纹', '内上角(肩胛骨)', '内缘(肩胛骨)', '外缘(肩胛骨)', '无压痛点'
        ]
        keyArr.forEach((ele: any, i: any) => {
            if (data.value[ele]) {
                showText.push(TextArr[i]);
            }
        })
        return showText
    } else if (type == '膝关节') {
        const keyArr = ['QT', 'LP', 'MP', 'PT', 'MJLA', 'SM', 'LJLA', 'SL', 'T', 'inside', 'outside']
        const TextArr = ['股四头肌肌腱(QT)', '外侧髌骨(LP)', '内侧髌骨(MP)', '髌骨肌腱(PT)', '内侧关节线区(MJLA)', '上内侧(SM)',
            '外侧关节线区(LJLA)',
            '上外侧(SL)',
            '胫骨(T)',
            '腓肠肌内侧头', '腓肠肌外侧头'
        ]
        keyArr.forEach((ele: any, i: any) => {
            if (ele === 'inside' || ele === 'outside') {
                if (data.value['R右侧'][ele]) {
                    showText.push(TextArr[i])
                }
            } else {
                if (data.value['L左侧'][ele]) {
                    showText.push(TextArr[i])
                }
            }
        })
        return showText
    }
}
/**
 * @description 控件必填题目是否未填
 * @param data{}// 控件数据
 * @returns 
 */
const IfEmpty = (data: any): any => {
    if (data.is_required && !data.hide) {
        return IfNoValue(data);
    } else {
        return false
    }
}
/**
 * @description 控件题目是否填写
 * @param data{}// 控件数据
 * @returns 
 */
const IfNoValue = (data: any): any => {

    if (data.type === "主标题" || data.type === "段落标题") {
        return false;
    } else if (data.type === "多选") {
        return data.value.length === 0;
    } else if (data.type === "计分单选" || data.type === "sf36计分单选") {
        return !data.value.name;
    } else if (data.type === "多选补充文字" || data.type === "单选补充文字") {
        let val = true;
        for (const opt of data["options"]) {
            if (opt.value) {
                val = false;
            }
        }
        return val;
    } else if (data.type === "压痛点") {
        if (data.setting == '腰椎病压痛点左侧' || data.setting == '腰椎病压痛点右侧') {
            const d: any = getText(data, '腰椎');
            if (d.length > 0) {
                return false
            } else {
                return true
            }
        } else if (data.setting == '正面压痛点左侧' || data.setting == '正面压痛点右侧') {
            const d: any = getText(data, '正面');
            if (d.length > 0) {
                return false
            } else {
                return true
            }
        } else if (data.setting == '侧面压痛点左侧' || data.setting == '侧面压痛点右侧') {
            const d: any = getText(data, '侧面');
            if (d.length > 0) {
                return false
            } else {
                return true
            }
        } else if (data.setting == '背面压痛点左侧' || data.setting == '背面压痛点右侧') {
            const d: any = getText(data, '背面');
            if (d.length > 0) {
                return false
            } else {
                return true
            }
        } else if (data.setting == '膝关节压痛点左膝' || data.setting == '膝关节压痛点右膝') {
            const d: any = getText(data, '膝关节');
            if (d.length > 0) {
                return false
            } else {
                return true
            }
        }
    } else if (data.type === "表格") {
        let value: any = true
        for (let i = 0; i < data.value.length; i++) {
            for (let j = 0; j < data.value[i].length; j++) {
                const d: any = data.value[i][j];
                // 二级表格不再验证,文本不需要验证
                if (d.type !== '表格' && d.type !== '文本') {
                    const result: any = IfNoValue(d);
                    if (!result) {
                        value = false
                    }
                }
            }
        }
        return value
    } else {
        return !data.value && data.value !== 0;
    }
}
/**
 * @description 生成题目联动数据
 * @param data{}
 * @returns 
 */
const getControlData = (data: any) => {
    if (data.type === "单选" || data.type === "下拉单选") {
        let index;
        data.options.forEach((ele: any, i: any) => {
            if (ele === data.value) {
                index = i;
            }
        });
        if (data.value) {
            data.control.index = [index];
        } else {
            data.control.index = [];
        }
    } else if (data.type === "计分单选" || data.type === "sf36计分单选") {
        let index;
        data.options.forEach((ele: any, i: any) => {
            if (ele.name === data.value.name) {
                index = i;
            }
        });
        if (data.value && data.value.name) {
            data.control.index = [index];
        } else {
            data.control.index = [];
        }
    } else if (data.type === "单选补充文字") {
        let index;
        let hasVal = false;
        data.options.forEach((ele: any, i: any) => {
            if (ele.value) {
                index = i;
                hasVal = true;
            }
        });
        if (hasVal) {
            data.control.index = [index];
        } else {
            data.control.index = [];
        }
    } else if (data.type === "多选") {
        const indexs: any = [];
        data.value.forEach((ele: any) => {
            data.options.forEach((item: any, i: any) => {
                if (ele === item) {
                    indexs.push(i);
                }
            });
        });
        if (indexs.length > 0) {
            data.control.index = indexs;
        } else {
            data.control.index = [];
        }
    } else if (data.type === "多选补充文字") {
        const indexs: any = [];
        data.options.forEach((ele: any, i: any) => {
            if (ele.value) {
                indexs.push(i);
            }
        });
        if (indexs.length > 0) {
            data.control.index = indexs;
        } else {
            data.control.index = [];
        }
    }
    return data;
}
/**
   * @description 隐藏或者显示某些相关题目
   */
const hideContent = (controlData: any, data: any) => {
    let arr: any = [];
    if (controlData.control.index.length === 0) {
        // 循环改值
        controlData.control.all.forEach((ele: any) => {
            const index = data.findIndex((val: any) => {
                return ele == val.id;
            });
            data[index]['hide'] = !controlData.control.hide;
            // 如果是隐藏需要清除值
            if (!controlData.control.hide) {
                clearVal(data[index]);
            }
        });
    } else {
        // 拼接数组
        controlData.control.index.forEach((ele: any) => {
            arr = arr.concat(controlData.control.list[ele]);
        });
        // 去重
        arr = Array.from(new Set(arr));
        controlData.control.all.forEach((ele: any) => {
            const index = data.findIndex((val: any) => {
                return ele == val.id;
            });
            const i = arr.findIndex((val: any) => {
                return ele == val;
            });
            if (i === -1) {
                // 找不到给hide相反的值
                data[index]['hide'] = !controlData.control.hide;
                // 如果是隐藏需要清除值
                if (!controlData.control.hide) {
                    clearVal(data[index]);
                }
            } else {
                // 找到给hide的值
                data[index]['hide'] = controlData.control.hide;
                // 如果是隐藏需要清除值
                if (controlData.control.hide) {
                    clearVal(data[index]);
                }
            }
        });
    }
    return data;
}
/**
 * @description 清除隐藏题目的value
 * @param data{}
 * @returns 
 */
const clearVal = (data: any) => {
    clearOne(data);
}
const clearOne = (data: any) => {
    if (data.type === "文本") {
        return
    }
    if (data.type === "计分单选" || data.type === "sf36计分单选") {
        data.value = {};
    } else if (data.type === "单选补充文字" || data.type === "多选补充文字") {
        data.options.forEach((ele: any) => {
            ele.value = false;
            if (ele.content) {
                ele.content = "";
            }
            if (ele.extra) {
                ele.extra.forEach((d: any) => {
                    clearOne(d);
                });
            }
        });
    } else if (data.type === "多选" || data.type === "动态数组") {
        data.value = [];
    } else if (data.type === "表格") {
        // 表格不处理清空值
    } else {
        data.value = "";
    }
}
/**
 * @description 验证必填
 * @param data,数组
 * @returns  
 */
const checkRequired = (data: any) => {
    let result: any = {
        ifPass: true,
        index: 0,
        data: {}
    }
    // 判断必填项是否填完
    for (let i = 0; i < data.length; i++) {
        const weitian = IfEmpty(data[i]);
        if (weitian) {
            result = {
                ifPass: false,
                index: i,
                data: data[i]
            }
            return result;
        }
    }
    return result;
}
/**
 * @description 获取选项
 * @param key 获取选项的关键字
 */
const getOptions = (key: any) => {
    let options: any = []
    switch (key) {
        case '有无':
            options = ['有', '无']
            break;
        case '舌色':
            options = ["淡", "淡红", "红", "暗红", "绛", "淡紫", "暗紫"]
            break;
        case '苔色':
            options = ["黄白相兼", "苔灰黑", "苔黄", "苔白", "苔无"]
            break;
        case '厚薄':
            options = ["厚", "薄"]
            break;
        case '胖瘦':
            options = ["胖瘦适中", "胖", "瘦"]
            break;
        case '面色':
            options = ["红黄隐隐，明润含蓄", "面色红", "面色白", "面色姜黄", "面色黄"]
            break;
        case '光泽':
            options = ["有光泽", "少量光泽", "无光泽"]
            break;
        case '唇色':
            options = ["唇色青紫", "唇色暗红", "唇色淡", "唇色红"]
            break;
        case '脉位':
            options = ["沉", "中", "浮"]
            break;
        case '脉率':
            options = ["中", "慢", "快", "缓", "数", "迟", "疾"]
            break;
        case '脉节律':
            options = ["齐", "不齐"]
            break;
        case '脉力':
            options = ["无力", "中", "有力"]
            break;
        case '脉名':
            options = [
                "脉虚弦促沉",
                "脉促而虚",
                "脉虚弦沉",
                "脉滑",
                "脉虚而代弦",
                "脉结弦",
                "脉虚浮促",
                "脉数",
                "脉虚",
                "脉弦",
                "脉结虚",
                "脉虚缓",
                "脉缓",
                "脉结",
                "脉虚弦结",
                "脉沉虚",
                "脉虚弦",
                "脉虚而代",
                "脉浮而滑结",
                "脉虚浮结",
                "脉沉而结虚",
                "脉迟而弦",
                "脉缓弦",
                "脉虚缓弦",
                "脉促",
                "脉浮数虚弦",
                "脉代而弦",
                "脉沉而数",
                "脉浮而滑结虚",
                "脉虚浮弦",
                "其它脉",
                "脉虚缓沉弦",
                "脉浮数虚",
                "脉虚浮结弦",
                "脉弦而数",
                "脉沉而迟弦",
                "脉虚弦促",
                "脉促而滑",
                "脉结滑",
                "脉沉弦",
                "脉迟",
                "脉浮",
                "脉沉弦结",
                "脉促而弦",
                "脉浮弦",
                "脉浮缓虚弦",
                "脉代",
                "脉沉缓弦",
                "脉沉而结",
                "脉浮而迟弦",
                "脉虚数",
                "脉虚弦结沉",
                "脉虚滑结",
                "脉虚弦数",
                "脉虚弦迟",
                "脉沉而数弦",
                "脉虚浮",
                "脉虚数沉",
                "脉沉滑",
                "脉缓滑",
                "脉平",
                "脉虚滑",
                "脉滑数",
                "脉沉缓",
                "脉虚浮代",
                "脉浮缓弦",
                "脉促沉",
                "脉沉弦促",
                "脉浮而结弦",
                "脉虚缓沉",
                "脉虚而代沉",
                "脉弦滑",
                "脉虚而代沉弦",
                "脉虚浮促弦",
                "脉促而虚沉",
                "脉浮而代弦",
                "脉沉",
                "脉浮而结",
                "脉虚滑促",
                "脉浮缓",
                "脉弦滑促",
                "脉虚弦数沉",
                "脉浮而滑促虚",
                "脉沉滑促",
                "脉沉滑结",
                "脉虚浮代弦",
                "脉虚浮疾",
                "脉弦滑结",
                "脉浮而滑促",
                "脉迟虚",
                "脉浮而滑",
                "脉虚滑促沉",
                "脉沉弦代",
                "脉沉而数滑弦",
                "脉浮而滑代",
                "脉浮而迟虚",
                "脉实而弦结",
                "脉沉而数滑",
                "脉沉滑弦",
                "脉虚滑结沉",
                "脉虚弦迟沉",
                "脉浮缓滑",
                "脉虚而代滑",
                "脉浮数弦",
                "脉虚缓滑",
                "脉迟滑",
                "脉沉而迟虚",
                "脉沉弦疾",
                "脉弦而数滑",
                "脉浮而迟虚弦",
                "脉虚数滑",
                "脉弦滑缓",
                "脉虚弦结滑",
                "脉疾而滑",
                "脉浮而滑虚",
                "脉代而滑",
                "脉沉而迟",
                "脉实",
                "脉浮数",
                "脉浮而滑促虚弦",
                "脉虚弦促滑",
                "脉沉滑结弦",
                "脉促浮",
                "脉疾而虚",
                "脉沉而代",
                "脉疾浮",
                "脉沉滑缓",
                "脉浮缓虚",
                "脉虚而代沉滑",
                "脉沉滑促弦",
                "脉浮数滑",
                "脉虚弦疾",
                "脉促而弦浮",
                "脉沉滑缓弦",
                "脉实而数滑",
                "脉浮而迟",
                "脉虚弦滑",
                "脉虚滑沉",
                "脉沉而迟滑弦",
                "脉疾",
                "脉浮数虚滑",
                "脉代而弦滑",
                "脉实而弦缓",
                "脉浮而代",
                "脉迟而弦滑",
                "脉疾而弦",
                "脉沉滑代",
                "脉虚数沉滑",
                "脉实而弦",
                "脉虚滑疾沉",
                "脉沉而迟滑",
                "脉实而滑缓",
                "脉结实",
                "脉实而滑结",
                "脉虚缓沉滑",
                "脉虚弦疾沉",
                "脉实而弦迟",
                "脉浮而滑代虚",
                "脉虚弦促沉滑",
                "脉浮而滑结虚弦",
                "脉虚弦迟沉滑",
                "脉疾而虚沉",
                "脉虚而代滑弦",
                "脉沉滑疾",
                "脉浮而滑迟",
                "脉虚弦结沉滑",
                "脉缓实",
            ]
            break;
        default:
            break;
    }
    return options;
}
/**
 * @description 获取层级选项，比如80舌象
 * @params type 类型，如舌象、面象
 * @param key 获取选项的关键字，一级名称，如舌色、苔色
 * @param level 获取选项的关键字，2/3 对应二级或三级选项，舌象80会有三级选项
 */
const getLevelOptions = (type: any, key: any, level: any) => {
    let options: any = []
    if (type == '舌象') {
        switch (key) {
            case '有无':
                if (level == 2) {
                    options = ['有', '无']
                }
                break;
            case '舌色':
                if (level == 2) {
                    options = ["淡", "淡红", "红", "暗红", "绛", "淡紫", "暗紫"]
                }
                break;
            case '苔色':
                if (level == 2) {
                    options = ["黄白相兼", "苔灰黑", "苔黄", "苔白", "苔无"]
                }
                break;
            case '厚薄':
                if (level == 2) {
                    options = ["厚", "薄"]
                }
                break;
            case '胖瘦':
                if (level == 2) {
                    options = ["胖瘦适中", "胖", "瘦"]
                }
                break;

            default:
                break;
        }
    } else if (type == '舌象80') {
        switch (key) {
            case '舌神':
                if (level == 2) {
                    options = ['荣', '枯']
                }
                break;
            case '舌色':
                if (level == 2) {
                    options = ['淡白', '淡红', "红", "绛", "青紫"]
                } else if (level == 3) {
                    options = ['枯白舌', '舌尖红', "舌边红", "舌淡紫无红（青舌）", "紫红舌", "舌淡紫发白"]
                }
                break;
            case '舌形':
                if (level == 2) {
                    options = ['胖', '瘦', '齿痕', '点刺', '裂纹', '老', "嫩", "滑", "卷曲"]
                } else if (level == 3) {
                    options = ['胖红', '胖淡', '瘦红', '瘦淡', '中间裂纹', '舌尖有瘀点']
                }
                break;
            case '舌态':
                if (level == 2) {
                    options = ['正常', '强直', '歪斜', '萎软', '吐弄', '短缩']
                } else if (level == 3) {
                    options = ['震颤', '短缩而卷']
                }
                break;
            case '苔质':
                if (level == 2) {
                    options = ['厚', '薄', '真', '假', '腐', '腻', '剥', '偏全', '少苔', '无苔', '润', '燥']
                } else if (level == 3) {
                    options = ['浮垢苔', '霉腐苔', '润苔', '滑苔', '燥苔', '糙苔', '前剥苔', '中剥苔', '根剥苔', '花剥苔', '镜面舌', '全苔', '偏苔', '粘腻苔', '垢苔']
                }
                break;
            case '苔色':
                if (level == 2) {
                    options = ['白', '黄', '灰黑']
                } else if (level == 3) {
                    options = ['薄白苔', '厚白苔', '浅黄苔', '深黄苔', '焦黄苔', '灰苔', '黑苔', '白如积粉（积粉苔）', '白燥裂苔']
                }
                break;
            default:
                break;
        }
    } else if (type == '舌底') {
        switch (key) {
            case '长度':
                if (level == 2) {
                    options = ['不足', '正常', '偏长']
                }
                break;
            case '形态':
                if (level == 2) {
                    options = ['单支', '双支', '有弯曲', '多支节', '有结节']
                }
                break;
            case '颜色':
                if (level == 2) {
                    options = ['淡红', '淡红含浅蓝', '暗红', '紫', '青紫', '深紫']
                }
                break;
            case '粗细':
                if (level == 2) {
                    options = ['紧束', '正常', '怒张']
                }
                break;
            default:
                break;
        }
    } else if (type == '面象') {
        switch (key) {
            case '有无':
                if (level == 2) {
                    options = ['有', '无']
                }
                break;
            case '面色':
                if (level == 2) {
                    options = ["红黄隐隐，明润含蓄", "面色红", "面色白", "面色姜黄", "面色黄"]
                }
                break;
            case '光泽':
                if (level == 2) {
                    options = ["有光泽", "少量光泽", "无光泽"]
                }
                break;
            case '唇色':
                if (level == 2) {
                    options = ["唇色青紫", "唇色暗红", "唇色淡", "唇色红"]
                }
                break;

            default:
                break;
        }
    } else if (type == '面象15') {
        switch (key) {
            case '唇态':
                if (level == 2) {
                    options = ['润', '燥', '皲裂', '脱皮', '发干', '过湿', '薄', '厚', '向左上扬', '向右上扬', '有凹陷', '唇裂（兔唇）', '下唇厚', '下唇突出', '不对称']
                }
                break;
            case '唇色':
                if (level == 2) {
                    // options = ['唇色苍白', '唇色淡白', '唇色红润（淡粉红色）', '唇色偏黄', '唇色暗红', '唇色偏紫', '唇色青紫', '唇色鲜红', '唇色乌青', '唇色发黑']
                    options = ['唇色红润', '唇色淡粉红', '上唇苍白', '下唇苍白', '唇色淡白', '唇色鲜红', '唇色暗红', '下唇偏红', '唇色胭脂红', '唇色樱桃红', '唇色发黄', '唇色干黄', '唇色发蓝', '唇色发青', '唇色青紫', '唇色发黑', '有紫黑斑块', '有浅白色斑块', '上唇淤青紫', '上唇淤青紫']
                }
                break;
            case '鼻光泽':
                if (level == 2) {
                    options = ['有光泽', '无光泽']
                }
                break;
            case '鼻形态':
                if (level == 2) {
                    options = ['偏大', '偏小', '正常', '鼻孔大', '鼻孔小', '鼻塌', '鼻尖', '鼻两翼突出']
                }
                break;
            case '鼻颜色':
                if (level == 2) {
                    options = ['红', '白', '正常肤', '偏黄', '偏黯', '鼻头红']
                }
                break;
            case '人中形态':
                if (level == 2) {
                    options = ['短浅', '狭长', '八字形', '有斑疹', '向左歪斜', '向右歪斜', '双人中']
                }
                break;
            case '人中颜色':
                if (level == 2) {
                    // options = ['正常肤色', '偏白', '偏红', '偏黄', '色青', '暗青', '灰暗']
                    options = ['正常肤色', '泛白', '偏白', '淡白', '发红', '近嘴唇红', '发黄', '偏黄', '发青', '青黑交错', '暗偏绿', '暗偏黑', '发黑', '偏紫', '淤青紫']
                }
                break;
            default:
                break;
        }
    } else if (type == '脉象' || type == '脉象6') {
        switch (key) {
            case '脉位':
                if (level == 2) {
                    options = ["沉", "中", "浮"]
                }
                break;
            case '脉率':
                if (level == 2) {
                    options = ["中", "慢", "快", "缓", "数", "迟", "疾"]
                }
                break;
            case '脉节律':
                if (level == 2) {
                    options = ["齐", "不齐"]
                }
                break;
            case '脉力':
                if (level == 2) {
                    options = ["无力", "中", "有力"]
                }
                break;
            case '脉名':
                if (level == 2) {
                    options = [
                        "脉虚弦促沉",
                        "脉促而虚",
                        "脉虚弦沉",
                        "脉滑",
                        "脉虚而代弦",
                        "脉结弦",
                        "脉虚浮促",
                        "脉数",
                        "脉虚",
                        "脉弦",
                        "脉结虚",
                        "脉虚缓",
                        "脉缓",
                        "脉结",
                        "脉虚弦结",
                        "脉沉虚",
                        "脉虚弦",
                        "脉虚而代",
                        "脉浮而滑结",
                        "脉虚浮结",
                        "脉沉而结虚",
                        "脉迟而弦",
                        "脉缓弦",
                        "脉虚缓弦",
                        "脉促",
                        "脉浮数虚弦",
                        "脉代而弦",
                        "脉沉而数",
                        "脉浮而滑结虚",
                        "脉虚浮弦",
                        "其它脉",
                        "脉虚缓沉弦",
                        "脉浮数虚",
                        "脉虚浮结弦",
                        "脉弦而数",
                        "脉沉而迟弦",
                        "脉虚弦促",
                        "脉促而滑",
                        "脉结滑",
                        "脉沉弦",
                        "脉迟",
                        "脉浮",
                        "脉沉弦结",
                        "脉促而弦",
                        "脉浮弦",
                        "脉浮缓虚弦",
                        "脉代",
                        "脉沉缓弦",
                        "脉沉而结",
                        "脉浮而迟弦",
                        "脉虚数",
                        "脉虚弦结沉",
                        "脉虚滑结",
                        "脉虚弦数",
                        "脉虚弦迟",
                        "脉沉而数弦",
                        "脉虚浮",
                        "脉虚数沉",
                        "脉沉滑",
                        "脉缓滑",
                        "脉平",
                        "脉虚滑",
                        "脉滑数",
                        "脉沉缓",
                        "脉虚浮代",
                        "脉浮缓弦",
                        "脉促沉",
                        "脉沉弦促",
                        "脉浮而结弦",
                        "脉虚缓沉",
                        "脉虚而代沉",
                        "脉弦滑",
                        "脉虚而代沉弦",
                        "脉虚浮促弦",
                        "脉促而虚沉",
                        "脉浮而代弦",
                        "脉沉",
                        "脉浮而结",
                        "脉虚滑促",
                        "脉浮缓",
                        "脉弦滑促",
                        "脉虚弦数沉",
                        "脉浮而滑促虚",
                        "脉沉滑促",
                        "脉沉滑结",
                        "脉虚浮代弦",
                        "脉虚浮疾",
                        "脉弦滑结",
                        "脉浮而滑促",
                        "脉迟虚",
                        "脉浮而滑",
                        "脉虚滑促沉",
                        "脉沉弦代",
                        "脉沉而数滑弦",
                        "脉浮而滑代",
                        "脉浮而迟虚",
                        "脉实而弦结",
                        "脉沉而数滑",
                        "脉沉滑弦",
                        "脉虚滑结沉",
                        "脉虚弦迟沉",
                        "脉浮缓滑",
                        "脉虚而代滑",
                        "脉浮数弦",
                        "脉虚缓滑",
                        "脉迟滑",
                        "脉沉而迟虚",
                        "脉沉弦疾",
                        "脉弦而数滑",
                        "脉浮而迟虚弦",
                        "脉虚数滑",
                        "脉弦滑缓",
                        "脉虚弦结滑",
                        "脉疾而滑",
                        "脉浮而滑虚",
                        "脉代而滑",
                        "脉沉而迟",
                        "脉实",
                        "脉浮数",
                        "脉浮而滑促虚弦",
                        "脉虚弦促滑",
                        "脉沉滑结弦",
                        "脉促浮",
                        "脉疾而虚",
                        "脉沉而代",
                        "脉疾浮",
                        "脉沉滑缓",
                        "脉浮缓虚",
                        "脉虚而代沉滑",
                        "脉沉滑促弦",
                        "脉浮数滑",
                        "脉虚弦疾",
                        "脉促而弦浮",
                        "脉沉滑缓弦",
                        "脉实而数滑",
                        "脉浮而迟",
                        "脉虚弦滑",
                        "脉虚滑沉",
                        "脉沉而迟滑弦",
                        "脉疾",
                        "脉浮数虚滑",
                        "脉代而弦滑",
                        "脉实而弦缓",
                        "脉浮而代",
                        "脉迟而弦滑",
                        "脉疾而弦",
                        "脉沉滑代",
                        "脉虚数沉滑",
                        "脉实而弦",
                        "脉虚滑疾沉",
                        "脉沉而迟滑",
                        "脉实而滑缓",
                        "脉结实",
                        "脉实而滑结",
                        "脉虚缓沉滑",
                        "脉虚弦疾沉",
                        "脉实而弦迟",
                        "脉浮而滑代虚",
                        "脉虚弦促沉滑",
                        "脉浮而滑结虚弦",
                        "脉虚弦迟沉滑",
                        "脉疾而虚沉",
                        "脉虚而代滑弦",
                        "脉沉滑疾",
                        "脉浮而滑迟",
                        "脉虚弦结沉滑",
                        "脉缓实",
                    ]
                }
                break;
            default:
                break;
        }
    }
    return options;
}
const initData = (data: any) => {
    console.log('处理默认值');
    console.log(data.data[0].type)
    if (data.data[0].type == '脉象') {
        if (
            data.report["左手脉象信息输出"] &&
            data.report["左手脉象信息输出"]["脉名"] == "其它脉"
        ) {
            data.report["左手脉象信息输出"]["脉名"] = "大脉";
        }
        if (
            data.report["右手脉象信息输出"] &&
            data.report["右手脉象信息输出"]["脉名"] == "其它脉"
        ) {
            data.report["右手脉象信息输出"]["脉名"] = "大脉";
        }
    } else if (data.data[0].type == '脉象6') {
        if (
            data.report["脉象信息输出"] &&
            data.report["脉象信息输出"]["脉名"] == "其它脉"
        ) {
            data.report["脉象信息输出"]["脉名"] = "大脉";
        }
    } else if (data.data[0].type == '舌象80') {
        if (data.report && !data.report["舌象信息"]) {
            data.report["舌象信息"] = {
                舌神: [[], []],
                舌色: [[], []],
                舌形: [[], []],
                舌态: [[], []],
                苔质: [[], []],
                苔色: [[], []],
            };
            // 转格式,填充数据
            const oldData: any = data.report["舌象信息输出"];
            // 舌色
            if (oldData[0]) {
                const text: any = oldData[0];
                data.report["舌象信息"]["舌色"][0].push(text);
            }
            // 边尖红
            if (oldData[1] && oldData[1] == "有") {
                data.report["舌象信息"]["舌色"][1].push("边尖红");
            }
            // 瘀斑瘀点
            if (oldData[2] && oldData[2] == "有") {
                data.report["舌象信息"]["舌形"][0].push("有瘀斑瘀点");
            }
            // 苔色
            if (oldData[3]) {
                const text: any = oldData[3];
                data.report["舌象信息"]["苔色"][0].push(text);
            }
            // 厚薄
            if (oldData[4]) {
                const text: any = oldData[4];
                data.report["舌象信息"]["苔质"][0].push(text);
            }
            // 腻
            if (oldData[5] && oldData[5] == "有") {
                data.report["舌象信息"]["苔质"][0].push("腻");
            }
            // 腐
            if (oldData[6] && oldData[6] == "有") {
                data.report["舌象信息"]["苔质"][0].push("腐");
            }
            // 苔剥
            if (oldData[7] && oldData[7] == "有") {
                data.report["舌象信息"]["苔质"][0].push("有苔剥");
            }
            // 胖瘦
            if (oldData[8]) {
                const text: any = oldData[8];
                data.report["舌象信息"]["舌形"][0].push(text);
            }
            // 齿痕
            if (oldData[9] && oldData[9] == "有") {
                data.report["舌象信息"]["舌形"][0].push("齿痕");
            }
            // 点刺
            if (oldData[10] && oldData[10] == "有") {
                data.report["舌象信息"]["舌形"][0].push("点刺");
            }
            // 裂纹
            if (oldData[11] && oldData[11] == "有") {
                data.report["舌象信息"]["舌形"][0].push("裂纹");
            }
            data.report["舌象信息"]["舌神"][0].push("荣");
            data.report["舌象信息"]["舌态"][0].push("正常");
        }
    } else if (data.data[0].type == '面象15') {
        if (!data.report["面象信息"]) {
            data.report["面象信息"] = {
                面色: [],
                唇态: ["润"],
                唇色: [],
                鼻光泽: ["有光泽"],
                鼻形态: ["正常"],
                鼻颜色: ["正常肤"],
                人中形态: ["短浅"],
                人中颜色: ["正常肤色"],
            };
            // 转格式,填充数据
            const oldData: any = data.report["面象信息输出"];
            // 面色
            if (oldData[0]) {
                const text: any = oldData[0];
                data.report["面象信息"]["面色"].push(text);
            }
            if (oldData[1] && oldData[1] == "有") {
                data.report["面象信息"]["面色"].push("两颧红");
            }
            if (oldData[2] && oldData[2] == "有") {
                data.report["面象信息"]["面色"].push("眼眶黑");
            }
            if (oldData[3]) {
                const text: any = oldData[3];
                data.report["面象信息"]["面色"].push(text);
            }

            // 唇色
            if (oldData[4]) {
                const text: any = oldData[4];
                data.report["面象信息"]["唇色"].push(text);
            }
        }
    } else if (data.data[0].type == '舌底') {
        if (!data.report["舌底信息"]) {
            data.report["舌底信息"] = {
                长度: "正常",
                形态: "双支",
                颜色: "淡红含浅蓝",
                粗细: "正常",
            };
        }
    }
    console.log('处理默认值的数据')
    console.log(data)
    return data;
}
/**
 * @description 获取当前时间
 * @param format 时间格式
 */
const getCurrentTime = (format: any) => {
    const now: any = new Date();
    const year: any = now.getFullYear(); // 得到年份
    let month: any = now.getMonth(); // 得到月份
    let date: any = now.getDate(); // 得到日期
    let hour: any = now.getHours(); // 得到小时
    let minu: any = now.getMinutes(); // 得到分钟
    let sec: any = now.getSeconds(); // 得到秒
    month = month + 1;
    if (month < 10) {
        month = "0" + month;
    }
    if (date < 10) {
        date = "0" + date;
    }
    if (hour < 10) {
        hour = "0" + hour;
    }
    if (minu < 10) {
        minu = "0" + minu;
    }
    if (sec < 10) {
        sec = "0" + sec;
    }
    let time = "";
    if (format == "yyyy") {
        time = year
    } else if (format == "yyyy-MM") {
        time = year + "-" + month
    } else if (format == "yyyy-MM-dd") {
        time = year + "-" + month + "-" + date
    } else if (format == "yyyy-MM-dd HH") {
        time = year + "-" + month + "-" + date + " " + hour
    } else if (format == "yyyy-MM-dd HH:mm") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu
    } else if (format == "yyyy-MM-dd HH:mm:ss") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
    }
    return time;
}
export {
    IfEmpty, IfNoValue, getControlData, hideContent, clearVal, clearOne,
    checkRequired, getOptions, getLevelOptions, initData, getCurrentTime
};